export const localizationRu = {
  main: 'Main',
  timeLinesCreateOrEdit: {
    objectX: {
      cell: {
        cellPreview: 'Превью ячеек',
        loadPreviewData: 'Загрузить данные превью',
      },
      keyField: 'Ключевое поле',
      linkToObjectX: 'Ссылка на Object X',
      linkDataBlock: {
        objectX: 'Данные Object X',
        links: 'Связи',
        toObjectY: 'Object Y',
        toColumnsObject: 'Объект колонок',
        fromColumnsObject: 'Поле из объекта колонок',
        fromObjectY: 'Поле из Object Y',
        columnsObject: 'Объект колонок',
        columnsObjectHint:
          'Эти данные будут использованы для отображения колонок. Сами данные будут браться из команды Object X.',
        columnsObjectNotSelected: 'Для заполнения этого поля необходимо выбрать объект колонок',
        goToColumnsObject: 'Перейти к объекту колонок',
        headerBlockLegend: 'Header',
        bindType: 'BindType',
        headerField: 'Поле заголовка',
        objectYNotSelected: 'Для заполнения этого поля необходимо выбрать Object Y',
        goToObjectY: 'Перейти к Object Y',
      },
    },
  },
}
